import ko from 'knockout';
import logger from '../../Vendor/inv-logger/logger';
import resourceHelper from '../../Vendor/inv-resource-helper/resourceHelper';
import contextData from './contextData';
import uploadManager from './utils/uploadManager';
import UploadModel from './models/uploadModel.ts';
import fileUploadSelecterComponent from './components/fileUploadSelecter/fileUploadSelecter';
import progressBarComponent from './components/progressBar/progressBar';
import './bindings/fileDropZoneBinding';
import './bindings/fileInputBinding';
import './bindings/fileSizeBinding';
import './bindings/uploadEngineBinding';
import resourceData from './resourceData';

function FileUpload() {

  var self = this;

  // Please ensure the supported language codes and default language code are all in lowercase
  var supportedLanguageCodes = ['en-us', 'cy', 'vi-vn'];
  var defaultLanguageCode = 'en-us';

  self.init = function (options) {

    // TODO: Add checks here for options to ensure all required exist

    contextData.init(options);
    retrieveAndSetResourceData(options.languageCode);
    registerComponents();
  };

  self.uploadManager = uploadManager;
  self.UploadModel = UploadModel;

  function retrieveAndSetResourceData(languageCode) {

    var languageCodeSupported;

    if (!languageCode) {
      logger.error(
        'UnhandledError',
        `The required parameter 'languageCode' was not provided when initializing the module 'inv-file-upload`);
    }

    languageCode = languageCode.toLowerCase();
    languageCodeSupported = supportedLanguageCodes.indexOf(languageCode) > -1;
    languageCode = languageCodeSupported ? languageCode : defaultLanguageCode;
    resourceHelper.registerPackageResourceData(resourceData[languageCode], 'inv-file-upload', languageCode);
  }

  function registerComponents() {
    ko.components.register('file-upload-selecter', fileUploadSelecterComponent);
    ko.components.register('progress-bar', progressBarComponent);
  }
}

export default new FileUpload();
